import React from "react";
import Image from "next/image";
import { IMGDESIGN_1, IMGDESIGN_2, IMGDESIGN_3 } from "@/constants/imagesUrl";
import ArrowIcon from "@/components/atoms/icons/ArrowIcon";
import { SText } from "@/components/atoms";
import SHeading from "@/components/atoms/SHeading";
import { useTranslation } from "react-i18next";

const FrameDesign = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col justify-between items-center">
      <SHeading text={t("home.frame_design.title")} tAlign="center" />
      <div className="flex flex-col items-center w-full mt-2">
        {/* Row ảnh + mũi tên - căn giữa theo ảnh */}
        <div className="flex items-center justify-center w-full gap-2 sm:gap-6">
          <Image
            src={IMGDESIGN_1}
            alt="design-1"
            width={194}
            height={143}
            className="w-[100px] h-auto sm:w-[150px] md:w-[194px] object-cover"
          />

          <div className="flex-shrink-0">
            <ArrowIcon />
          </div>

          <div className="flex gap-1 sm:gap-2">
            <Image
              src={IMGDESIGN_2}
              alt="design-2"
              width={79}
              height={100}
              className="w-[52px] h-auto sm:w-[65px] md:w-[79px] object-cover"
            />
            <Image
              src={IMGDESIGN_3}
              alt="design-3"
              width={79}
              height={100}
              className="w-[52px] h-auto sm:w-[65px] md:w-[79px] object-cover"
            />
          </div>
        </div>

        {/* Row caption - dùng invisible spacer để căn đúng vị trí */}
        <div className="flex justify-center w-full gap-2 sm:gap-6 mt-3 sm:mt-5">
          <SText
            text={t("home.frame_design.description1")}
            className="text-xs text-center w-[100px] sm:w-[150px] md:w-[194px]"
          />
          <div className="flex-shrink-0 invisible">
            <ArrowIcon />
          </div>
          <SText
            text={t("home.frame_design.description2")}
            className="text-xs text-center w-[105px] sm:w-[132px] md:w-[160px]"
          />
        </div>
      </div>
    </div>
  );
};

export default FrameDesign;
